var _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEm300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "24.04 3.66 8.75 20.26 16.52 19.18 8.75 30 24.46 13.75 16.61 15.07 24.04 3.66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.5,16.81c-.15-.43-.61-.66-1.05-.52-.43.15-.66.61-.52,1.05,1.25,3.72.58,7.26-1.76,9.24-1.66,1.4-3.95,1.87-6.46,1.31-2.6-.57-5.1-2.16-7.04-4.46-3.2-3.78-4.07-8.55-2.46-11.8.45.15,1.04.2,1.55-.23.98-.83,1.82-1.62,1.82-1.62,1.5.69,3.32.48,4.63-.69l.66-.59c.42-.38.46-1.02.08-1.45l-.33-.37,2.67-2.37c.34-.3.37-.82.07-1.16-.3-.34-.82-.37-1.16-.07l-2.67,2.37-1.46-1.64,2.67-2.37c.34-.3.37-.82.07-1.16-.3-.34-.82-.37-1.16-.07l-2.67,2.37-.33-.37c-.38-.42-1.02-.46-1.45-.08l-.66.59c-1.15,1.02-1.61,2.53-1.36,3.94,0,0-1.52,1.35-2.33,2.08-.47.42-.19,1.18.13,1.76-2.17,3.85-1.31,9.57,2.45,14.01,2.18,2.57,5,4.35,7.95,5,.81.18,1.61.27,2.38.27,2.1,0,4-.66,5.5-1.93,2.86-2.42,3.73-6.65,2.26-11.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEm300);
export default __webpack_public_path__ + "static/media/EM300.93f976583b5389cf4597c7ab625905ec.svg";
export { ForwardRef as ReactComponent };